module.exports = __webpack_public_path__ + "static/media/illusTerms.bdab55a0.png";